import http from 'utils/http';
import { SendCodeRequest, VerifyCodeRequest, VerifyCodeResponse } from './types';
import { getSendVerificationCodeUrl, getVerificationCodeUrl } from './apiUrls';

export function sendEmailForCode(payload: SendCodeRequest): Promise<void> {
  return http.post(getSendVerificationCodeUrl(), payload);
}

export function sendVerificationCode(payload: VerifyCodeRequest): Promise<VerifyCodeResponse> {
  return http.post(getVerificationCodeUrl(), payload);
}
